import React, { useEffect, useState } from 'react';
import { Spin, Table } from 'antd';
import {
    blog_columns
} from './fixtures';

import { getBlogs } from '../../api';

const BlogsList = ({ type }) => {

    const [data, setData] = useState();
    const [loading, setLoading] = useState();

    useEffect(() => {
        _getBlogs({ page: 1, limit: 10 });
    }, [type]);

    const _getBlogs = (payload) => {
        setLoading(true);
        getBlogs({ ...payload, type })
            .then(res => {
                if(res.status === 200) {
                    let parsedData = res.data.map(d => ({ ...d, key: d._id, edit_url: `/blogs/edit`}))
                    setData(parsedData);
                } else {
                    throw new Error('status not handled');
                }
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                setLoading(false);
            })
    }

    return (
        <Table
            columns={blog_columns}
            dataSource={data}
            loading={loading}
        />
    )
}

export default BlogsList;
